import type {
  ParticipantAccessLevel,
  SessionAccessLevel,
} from "@app/common/types";

import type { DropdownItem } from "@rui/Dropdown/types";

import type { UpcomingEventMeetingRecapRecipient } from "../utils";

export type ShareableRole = Extract<SessionAccessLevel, "owner" | "editor">;

export const CONTENT_FOR_PREDICTED_ROLE: {
  [key in ShareableRole]: { title: string; description: string; note: string };
} = {
  owner: {
    title: "Report Owner",
    description:
      "Your sharing and distribution settings will be enforced for this report.",
    note: "other participants who add Read will get editor access, and any editor can share the report with others, regardless of your own sharing preferences.",
  },
  editor: {
    title: "Editor",
    description:
      "Your sharing and distribution settings will be used for this report.",
    note: "as an editor, your preferences will be combined with other editors' preferences and have the potential to be overridden by the report owner.",
  },
};

export const ACCESS_LEVEL_OPTIONS: {
  value: ParticipantAccessLevel;
  label: string;
}[] = [
  { value: "editor", label: "Editor" },
  { value: "viewer_full", label: "Viewer" },
  { value: "no_access", label: "None" },
];

export const MEETING_RECAP_OPTIONS: DropdownItem<UpcomingEventMeetingRecapRecipient>[] =
  [
    { value: "everyone", label: "Me + participants with access" },
    { value: "just_me", label: "Just me" },
    { value: "no_one", label: "No one" },
  ];
